import { render } from "./LayoutHeader.vue?vue&type=template&id=4f2bff45"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__